<div class="wrapper">
    <!-- Reusable per-HMO exam-code editor (shown only when that HMO is checked) -->
    <ng-template #hmoCodes let-row="row" let-hmo="hmo" let-editing="editing">
      <div *ngIf="row[hmo] && (editing || codeArr(row, hmo).length > 0)" class="hmo-code-editor" style="margin: 0.2em 0 0.3em 0; text-align: right;">
        <small style="display:block; font-weight:bold; font-size:0.9em; color:#555;">{{ hmoTranslateKey(hmo) | translate }}</small>
        <div *ngFor="let c of codeArr(row, hmo); let ci = index; trackBy: trackByIndex"
             style="display:flex; align-items:center; gap:0.2em; margin: 0.1em 0;">
          <input class="search-patient-field menstural-field" style="width: 120px; font-size:0.85em;"
                 [(ngModel)]="row[hmo + 'Code'][ci]" [disabled]="!editing"
                 placeholder="{{ 'appointments.gui.labels.Exam Code' | translate }}">
          <button type="button" class="arrow-btn" *ngIf="editing" (click)="removeCode(row, hmo, ci)">✖</button>
        </div>
        <button type="button" class="blue-btn" *ngIf="editing" style="padding: 0 0.4em; font-size: 0.75em;"
                (click)="addCode(row, hmo)">＋ {{ 'appointments.gui.buttons.Add Code' | translate }}</button>
      </div>
    </ng-template>

    <div class="m-box">
      <app-rooms *ngIf="addRoom" (closed)="addRoom=false"></app-rooms>
      <app-multi-select-manager *ngIf="showMultiManager" (closed)="showMultiManager=false"></app-multi-select-manager>
        <h2>
          {{'appointments.gui.labels.Exams Details' | translate}}
        </h2>
        <table style="font-size: 0.85em;">
            <tr>
              <th>
           {{'appointments.gui.examsinclude in self appointments' | translate}}
              </th>
            <th>
              {{'appointments.gui.labels.Exam Type' | translate}}
            </th>
            <th>
              {{'billing.gui.labels.Exam Name' | translate}}
            </th>
            <th>
              {{'appointments.gui.labels.Duration (min)' | translate}}
            </th>
            <th *ngIf="!ls?.premissions?.ApptsByRoom">
              {{'appointments.gui.labels.Doctors' | translate}}
            </th>
            <th *ngIf="ls?.premissions?.ApptsByRoom">
              {{'appointments.gui.label.rooms' | translate}}
            </th>
            <th>
              {{'appointments.gui.labels.Color' | translate}}
            </th>
            <th>
              {{ 'appointments.gui.labels.Payer' | translate }}
              </th>
            <th *ngIf="ls.isObgyn">
              {{'appointments.gui.labels.Min Week' | translate}}
            </th>
            <th *ngIf="ls.isObgyn">
              {{'appointments.gui.labels.Max Week' | translate}}
            </th>
            <th *ngIf="ls?.premissions?.ApptsByRoom">
             <button (click)="addRoom=true"  class="blue-btn">{{'appointments.gui.buttons.add room' | translate}}</button>
            </th>
            <th *ngIf="ls.premissions && ls.premissions?.multiSelect">
              <button (click)="showMultiManager = true" class="blue-btn">
                {{'appointments.gui.buttons.Groups' | translate}}
              </button>
            </th>

            </tr>
            <tr [ngClass]="exam.isEditing ? 'tr-isActive' : ''" *ngFor="let exam of exams;let i = index">
              <td>
                <label class="t-label-top " style="margin-bottom: 1em;">
                  <input
                    type="checkbox"
                    class="custom-check -sq"
                    [(ngModel)]="exam.selfAppointment"
                    [disabled]="!exam.isEditing"
                  />
                  <i class="customInput-display -sq" (dblclick)="exam.selfAppointment = false"></i>
                </label>

              </td>
              <td style="width: 17%;">
                <select class="t-select w100" [(ngModel)]="exam.examType" [disabled]="!isStageEnvironment()">
                  <option *ngFor="let type of getExamTypes()" [value]="type">
                    {{ 'appointments.gui.exams.'+type | translate }}
                  </option>
                </select>
                <select *ngIf="(ls.isUSG || ls.isGastro) && exam.examType == 'Clinics'" class="t-select w100" [(ngModel)]="exam.ClinicTemplateID" [compareWith]="compareById" (ngModelChange)="onClinicTemplateChange(exam)" [disabled]="!exam.isEditing">
                  <option [ngValue]="null">{{ 'appointments.gui.labels.Select Clinic Template' | translate }}</option>
                  <option *ngFor="let template of clinicTemplates" [ngValue]="template.ClinicTemplateID">{{ template.Title }}</option>
                </select>
                <ng-container *ngFor="let hmo of hmoCodeList">
                  <ng-container *ngTemplateOutlet="hmoCodes; context: {row: exam, hmo: hmo, editing: exam.isEditing}"></ng-container>
                </ng-container>
              </td>
              <td style="width: 17%;"><input class="search-patient-field   menstural-field"  [(ngModel)]="exam.examName" [disabled]="!exam.isEditing"></td>
              <td>
                <ng-container *ngIf="settingsService.categories.Pregnancy.includes(exam.examType) || settingsService.categories['Fetal Echo'].includes(exam.examType)" >
                <label class="t-label-top">
                  <input class="search-patient-field  menstural-field" [(ngModel)]="exam.Length"  [disabled]="!exam.isEditing">
                  <span>{{'appointments.gui.labels.Singleton' | translate}}</span>
              </label>
              <label class="t-label-top">
                <input class="search-patient-field  menstural-field" [(ngModel)]="exam.LengthTwins"  [disabled]="!exam.isEditing">
                <span>{{'appointments.gui.labels.Twins' | translate}}</span>
                        </label>
            </ng-container>
                <input *ngIf="!settingsService.categories.Pregnancy.includes(exam.examType) && !settingsService.categories['Fetal Echo'].includes(exam.examType) "  class="search-patient-field  menstural-field" type="number" [(ngModel)]="exam.Length"  [disabled]="!exam.isEditing">

              </td>
              <!-- <td><input class="search-patient-field   menstural-field" type="number" [(ngModel)]="exam.Price" [disabled]="!exam.isEditing"></td> -->
              <td *ngIf="!ls?.premissions?.ApptsByRoom"><mat-form-field >
                <mat-label [ngClass]="['mat-select-value']">
                  {{'appointments.gui.labels.Practicing Doctor' | translate}}
                </mat-label>
                <mat-select [(ngModel)]="exam.users" multiple [compareWith]="compareById" [ngClass]="['mat-select-value','mat-form-field']" >
                  <ng-container *ngFor="let e of this.ls.clinicUsers">
                  <mat-option  [disabled]="!exam.isEditing"  [value]="e.UID" [ngClass]="['mat-select-value']">{{ e.Name }}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field></td>
              <td *ngIf="ls?.premissions?.ApptsByRoom"><mat-form-field >
                <mat-label [ngClass]="['mat-select-value']">
                  {{'appointments.gui.label.rooms' | translate}}
                </mat-label>
                <mat-select [(ngModel)]="exam.users" multiple [compareWith]="compareById" [ngClass]="['mat-select-value','mat-form-field']" >
                  <ng-container *ngFor="let e of this.ls.activeRooms">
                  <mat-option  [disabled]="!exam.isEditing"  [value]="e.AutoIndex" [ngClass]="['mat-select-value']">{{ ls.roomLabel(e) }}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field></td>
              <td><input class="color-picker" [(ngModel)]="exam.Color" type="color" [disabled]="!exam.isEditing"></td>
              <td>
                <div style="display:grid; grid-template-columns:1fr 1fr; gap:0.1em 0.4em;">
                  <label class="t-label-top">
                    <input type="checkbox" class="custom-check -sq" [(ngModel)]="exam.Private" [disabled]="!exam.isEditing"/>
                    <i class="customInput-display -sq" (dblclick)="exam.Private = false"></i>
                    <span>{{ 'appointments.gui.labels.Private' | translate }}</span>
                  </label>
                  <label class="t-label-top">
                    <input type="checkbox" class="custom-check -sq" [(ngModel)]="exam.Macabi" [disabled]="!exam.isEditing"/>
                    <i class="customInput-display -sq" (dblclick)="exam.Macabi = false"></i>
                    <span>{{ 'appointments.gui.hmo.Macabi' | translate }}</span>
                  </label>
                  <label class="t-label-top">
                    <input type="checkbox" class="custom-check -sq" [(ngModel)]="exam.Clalit" [disabled]="!exam.isEditing"/>
                    <i class="customInput-display -sq" (dblclick)="exam.Clalit = false"></i>
                    <span>{{ 'appointments.gui.hmo.Clalit' | translate }}</span>
                  </label>
                  <label class="t-label-top">
                    <input type="checkbox" class="custom-check -sq" [(ngModel)]="exam.Leumit" [disabled]="!exam.isEditing"/>
                    <i class="customInput-display -sq" (dblclick)="exam.Leumit = false"></i>
                    <span>{{ 'appointments.gui.hmo.Leumit' | translate }}</span>
                  </label>
                  <label class="t-label-top">
                    <input type="checkbox" class="custom-check -sq" [(ngModel)]="exam.Meuhedet" [disabled]="!exam.isEditing"/>
                    <i class="customInput-display -sq" (dblclick)="exam.Meuhedet = false"></i>
                    <span>{{ 'appointments.gui.hmo.Meuhedet' | translate }}</span>
                  </label>
                  <label class="t-label-top">
                    <input type="checkbox" class="custom-check -sq" [(ngModel)]="exam.IDF" [disabled]="!exam.isEditing"/>
                    <i class="customInput-display -sq" (dblclick)="exam.IDF = false"></i>
                    <span>{{ 'appointments.gui.selects.IDF' | translate }}</span>
                  </label>
                </div>
              </td>
              <td *ngIf="ls.isObgyn">
                <input class="search-patient-field   menstural-field" type="number" style="width: 70%;" [(ngModel)]="exam.minWeeks" [disabled]="!exam.isEditing">w
                <input class="search-patient-field   menstural-field" type="number" style="width: 70%;" [(ngModel)]="exam.minDays" [disabled]="!exam.isEditing">d
              </td>
              <td *ngIf="ls.isObgyn">
                <input class="search-patient-field  menstural-field" type="number"  style="width: 70%;" [(ngModel)]="exam.maxWeeks" [disabled]="!exam.isEditing">w
                <input class="search-patient-field   menstural-field" type="number"style="width: 70%;" [(ngModel)]="exam.maxDays" [disabled]="!exam.isEditing">d

              </td>
              <td>
                <button class="blue-btn" *ngIf="!exam.isEditing" (click)="editExam(exam)">
                  {{'appointments.gui.buttons.Edit' | translate}}
                </button>
                <button class="blue-btn"*ngIf="exam.isEditing" (click)="saveChanges(exam)">
                  {{'appointments.gui.buttons.Save' | translate}}
                </button>
                <button class="orange-btn"  (click)="deleteExam(exam)">
                  {{'appointments.gui.buttons.Delete' | translate}}
                </button>
              </td>
              <td>
                <button *ngIf="i > 0" (click)="orderExams(i, 'up')" [disabled]="i === 0" class="arrow-btn">⬆️</button>
                <button *ngIf="i < exams.length - 1" (click)="orderExams(i, 'down')" [disabled]="i === exams.length - 1" class="arrow-btn">⬇️</button>
              </td>
            </tr>
            <tr>
              <td>
                <label class="t-label-top " style="margin-bottom: 1em;">
                  <input
                    type="checkbox"
                    class="custom-check -sq"
                    [(ngModel)]="newExam.selfAppointment"
                  />
                  <i class="customInput-display -sq" (dblclick)="newExam.selfAppointment = false"></i>
                </label>

              </td>
                <td>
                  <select class="t-select w100" [(ngModel)]="newExam.examType" >
                    <option *ngFor="let type of getExamTypes()" [value]="type">
                      {{ 'appointments.gui.exams.'+type | translate }}
                    </option>
                  </select>
                  <select *ngIf="(ls.isUSG || ls.isGastro) && newExam.examType == 'Clinics'" class="t-select w100" [(ngModel)]="newExam['ClinicTemplateID']" [compareWith]="compareById" (ngModelChange)="onClinicTemplateChange(newExam)">
                    <option [ngValue]="null">{{ 'appointments.gui.labels.Select Clinic Template' | translate }}</option>
                    <option *ngFor="let template of clinicTemplates" [ngValue]="template.ClinicTemplateID">{{ template.Title }}</option>
                  </select>
                  <ng-container *ngFor="let hmo of hmoCodeList">
                    <ng-container *ngTemplateOutlet="hmoCodes; context: {row: newExam, hmo: hmo, editing: true}"></ng-container>
                  </ng-container>
                </td>
                  <td style="width: 17%;"><input class="search-patient-field   menstural-field"  [(ngModel)]="newExam.examName" ></td>
                <td>
                  <ng-container *ngIf="settingsService.categories.Pregnancy.includes(newExam.examType) || settingsService.categories['Fetal Echo'].includes(newExam.examType)" >
                    <label class="t-label-top">
                      <input class="search-patient-field  menstural-field" [(ngModel)]="newExam.Length" >
                      <span>{{'appointments.gui.labels.Singleton' | translate}}</span>
                    </label>
                  <label class="t-label-top">
                    <input class="search-patient-field  menstural-field" [(ngModel)]="newExam.LengthTwins"  >
                    <span>{{'appointments.gui.labels.Twins' | translate}}</span>
                  </label>
                </ng-container >
                  <input *ngIf="!settingsService.categories.Pregnancy.includes(newExam.examType) && !settingsService.categories['Fetal Echo'].includes(newExam.examType) " class="search-patient-field   menstural-field" [(ngModel)]="newExam.Length">
                </td>
              <td *ngIf="!ls?.premissions?.ApptsByRoom"><mat-form-field>
                <mat-label [ngClass]="['mat-select-value']">
                  {{'appointments.gui.labels.Choose Practicing Doctor' | translate}}
                </mat-label>
                <mat-select [(ngModel)]="newExam.users" multiple [compareWith]="compareById" [ngClass]="['mat-select-value','mat-form-field']">
                  <ng-container *ngFor="let e of this.ls.clinicUsers">
                  <mat-option   [value]="e.UID" [ngClass]="['mat-select-value']">{{ e.Name }}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field></td>
              <td *ngIf="ls?.premissions?.ApptsByRoom"><mat-form-field>
                <mat-label [ngClass]="['mat-select-value']">
                  {{'appointments.gui.labels.Choose Practicing rooms' | translate}}
                </mat-label>
                <mat-select [(ngModel)]="newExam.users" multiple [compareWith]="compareById" [ngClass]="['mat-select-value','mat-form-field']">
                  <ng-container *ngFor="let e of this.ls.activeRooms">
                  <mat-option   [value]="e.AutoIndex" [ngClass]="['mat-select-value']">{{ ls.roomLabel(e) }}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field></td>
              <td><input class="color-picker" [(ngModel)]="newExam.Color" type="color"></td>
              <td>
                <div style="display:grid; grid-template-columns:1fr 1fr; gap:0.1em 0.4em;">
                  <label class="t-label-top">
                    <input type="checkbox" class="custom-check -sq" [(ngModel)]="newExam.Private"/>
                    <i class="customInput-display -sq" (dblclick)="newExam.Private = false"></i>
                    <span>{{ 'appointments.gui.labels.Private' | translate }}</span>
                  </label>
                  <label class="t-label-top">
                    <input type="checkbox" class="custom-check -sq" [(ngModel)]="newExam.Macabi"/>
                    <i class="customInput-display -sq" (dblclick)="newExam.Macabi = false"></i>
                    <span>{{ 'appointments.gui.hmo.Macabi' | translate }}</span>
                  </label>
                  <label class="t-label-top">
                    <input type="checkbox" class="custom-check -sq" [(ngModel)]="newExam.Clalit"/>
                    <i class="customInput-display -sq" (dblclick)="newExam.Clalit = false"></i>
                    <span>{{ 'appointments.gui.hmo.Clalit' | translate }}</span>
                  </label>
                  <label class="t-label-top">
                    <input type="checkbox" class="custom-check -sq" [(ngModel)]="newExam.Leumit"/>
                    <i class="customInput-display -sq" (dblclick)="newExam.Leumit = false"></i>
                    <span>{{ 'appointments.gui.hmo.Leumit' | translate }}</span>
                  </label>
                  <label class="t-label-top">
                    <input type="checkbox" class="custom-check -sq" [(ngModel)]="newExam.Meuhedet"/>
                    <i class="customInput-display -sq" (dblclick)="newExam.Meuhedet = false"></i>
                    <span>{{ 'appointments.gui.hmo.Meuhedet' | translate }}</span>
                  </label>
                  <label class="t-label-top">
                    <input type="checkbox" class="custom-check -sq" [(ngModel)]="newExam.IDF"/>
                    <i class="customInput-display -sq" (dblclick)="newExam.IDF = false"></i>
                    <span>{{ 'appointments.gui.selects.IDF' | translate }}</span>
                  </label>
                </div>
              </td>
              <td *ngIf="ls.isObgyn">
                <input min="0" class="search-patient-field  menstural-field" style="width: 70%;" type="number" [(ngModel)]="newExam.minWeeks">w
                <input min="0" class="search-patient-field  menstural-field" style="width: 70%;" type="number" [(ngModel)]="newExam.minDays">d
              </td>
              <td *ngIf="ls.isObgyn">
                <input min="0" class="search-patient-field  menstural-field" style="width: 70%;" type="number" [(ngModel)]="newExam.maxWeeks">w
                <input min="0" class="search-patient-field   menstural-field"style="width: 70%;" type="number" [(ngModel)]="newExam.maxDays">d
              </td>
              <td><button style="white-space: nowrap;" class="orange-btn" (click)="saveNewExam(newExam)">
                {{'appointments.gui.buttons.Save New' | translate}}
              </button></td>
            </tr>
          </table>
    </div>

    <div class="m-box">
      <h2>
        {{'appointments.gui.labels.Custom Exams' | translate}}
      </h2>
      <table style="font-size: 0.85em;">
          <tr>
            <th>
              {{'appointments.gui.examsinclude in self appointments' | translate}}
             </th>
          <th>
            {{'appointments.gui.labels.Name' | translate}}
          </th>
          <th>
            {{'appointments.gui.labels.Duration (min)' | translate}}
          </th>
           <th>
            {{'appointments.gui.labels.Price' | translate}}
          </th>
           <th *ngIf="!ls?.premissions?.ApptsByRoom">
            {{'appointments.gui.labels.Doctors' | translate}}
          </th>
          <th *ngIf="ls?.premissions?.ApptsByRoom">
            {{'appointments.gui.label.rooms' | translate}}
          </th>
          <th>
            {{'appointments.gui.labels.Color' | translate}}
          </th>
          <th>
            {{ 'appointments.gui.labels.Payer' | translate }}
            </th>


          </tr>
          <tr [ngClass]="exam.isEditing? 'tr-isActive' : ''" *ngFor="let exam of customExams;let i= index">
            <td>
              <label class="t-label-top " style="margin-bottom: 1em;">
                <input
                  type="checkbox"
                  class="custom-check -sq"
                  [(ngModel)]="exam.selfAppointment"
                  [disabled]="!exam.isEditing"
                />
                <i class="customInput-display -sq" (dblclick)="exam.selfAppointment = false"></i>
              </label>

            </td>
            <td style="width: 17%;">
              <input class="search-patient-field   menstural-field" type="text" [(ngModel)]="exam.examType" [disabled]="!exam.isEditing">
              <ng-container *ngFor="let hmo of hmoCodeList">
                <ng-container *ngTemplateOutlet="hmoCodes; context: {row: exam, hmo: hmo, editing: exam.isEditing}"></ng-container>
              </ng-container>
            </td>
            <td><input class="search-patient-field  menstural-field" type="number" [(ngModel)]="exam.Length"  [disabled]="!exam.isEditing"></td>
             <td style="width: 17%;">
                <input class="search-patient-field   menstural-field w40" type="number" [(ngModel)]="exam.Price" [disabled]="!exam.isEditing">
            </td>
            <td *ngIf="!ls?.premissions?.ApptsByRoom"><mat-form-field >
              <mat-label [ngClass]="['mat-select-value']">
                {{'appointments.gui.labels.Practicing Doctor' | translate}}
              </mat-label>
              <mat-select [(ngModel)]="exam.users" multiple [compareWith]="compareById" [ngClass]="['mat-select-value','mat-form-field']" >
                <ng-container *ngFor="let e of this.ls.clinicUsers">
                <mat-option  [disabled]="!exam.isEditing"  [value]="e.UID" [ngClass]="['mat-select-value']">{{ e.Name }}</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field></td>
            <td *ngIf="ls?.premissions?.ApptsByRoom"><mat-form-field>
              <mat-label [ngClass]="['mat-select-value']">
                {{'appointments.gui.labels.Choose Practicing rooms' | translate}}
              </mat-label>
              <mat-select [(ngModel)]="exam.users" multiple [compareWith]="compareById" [ngClass]="['mat-select-value','mat-form-field']">
                <ng-container *ngFor="let e of this.ls.activeRooms">
                <mat-option   [value]="e.AutoIndex" [ngClass]="['mat-select-value']">{{ ls.roomLabel(e) }}</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field></td>
            <td><input class="color-picker" [(ngModel)]="exam.Color" type="color" [disabled]="!exam.isEditing"></td>
            <td>
              <div style="display:grid; grid-template-columns:1fr 1fr; gap:0.1em 0.4em;">
                <label class="t-label-top">
                  <input type="checkbox" class="custom-check -sq" [(ngModel)]="exam.Private" [disabled]="!exam.isEditing"/>
                  <i class="customInput-display -sq" (dblclick)="exam.Private = false"></i>
                  <span>{{ 'appointments.gui.labels.Private' | translate }}</span>
                </label>
                <label class="t-label-top">
                  <input type="checkbox" class="custom-check -sq" [(ngModel)]="exam.Macabi" [disabled]="!exam.isEditing"/>
                  <i class="customInput-display -sq" (dblclick)="exam.Macabi = false"></i>
                  <span>{{ 'appointments.gui.hmo.Macabi' | translate }}</span>
                </label>
                <label class="t-label-top">
                  <input type="checkbox" class="custom-check -sq" [(ngModel)]="exam.Clalit" [disabled]="!exam.isEditing"/>
                  <i class="customInput-display -sq" (dblclick)="exam.Clalit = false"></i>
                  <span>{{ 'appointments.gui.hmo.Clalit' | translate }}</span>
                </label>
                <label class="t-label-top">
                  <input type="checkbox" class="custom-check -sq" [(ngModel)]="exam.Leumit" [disabled]="!exam.isEditing"/>
                  <i class="customInput-display -sq" (dblclick)="exam.Leumit = false"></i>
                  <span>{{ 'appointments.gui.hmo.Leumit' | translate }}</span>
                </label>
                <label class="t-label-top">
                  <input type="checkbox" class="custom-check -sq" [(ngModel)]="exam.Meuhedet" [disabled]="!exam.isEditing"/>
                  <i class="customInput-display -sq" (dblclick)="exam.Meuhedet = false"></i>
                  <span>{{ 'appointments.gui.hmo.Meuhedet' | translate }}</span>
                </label>
                <label class="t-label-top">
                  <input type="checkbox" class="custom-check -sq" [(ngModel)]="exam.IDF" [disabled]="!exam.isEditing"/>
                  <i class="customInput-display -sq" (dblclick)="exam.IDF = false"></i>
                  <span>{{ 'appointments.gui.selects.IDF' | translate }}</span>
                </label>
              </div>
            </td>
            <td>
              <button class="blue-btn" *ngIf="!exam.isEditing" (click)="editExam(exam)">
                {{'appointments.gui.buttons.Edit' | translate}}
              </button>
              <button class="blue-btn" *ngIf="exam.isEditing" (click)="saveChanges(exam)">
                {{'appointments.gui.buttons.Save' | translate}}
              </button>
              <button class="orange-btn"  (click)="deleteExam(exam)">
                {{'appointments.gui.buttons.Delete' | translate}}
              </button>
            </td>
            <td>
              <button *ngIf="i > 0" (click)="orderExams(i, 'up',true)" [disabled]="i === 0" class="arrow-btn">⬆️</button>
              <button *ngIf="i < exams.length - 1" (click)="orderExams(i, 'down',true)" [disabled]="i === exams.length - 1" class="arrow-btn">⬇️</button>
            </td>
          </tr>
          <tr>
            <td>
              <label class="t-label-top " style="margin-bottom: 1em;">
                <input
                  type="checkbox"
                  class="custom-check -sq"
                  [(ngModel)]="customNewExam.selfAppointment"
                />
                <i class="customInput-display -sq" (dblclick)="customNewExam.selfAppointment = false"></i>
              </label>

            </td>
              <td>
                <input class="search-patient-field  menstural-field" [(ngModel)]="customNewExam.examType">
                <ng-container *ngFor="let hmo of hmoCodeList">
                  <ng-container *ngTemplateOutlet="hmoCodes; context: {row: customNewExam, hmo: hmo, editing: true}"></ng-container>
                </ng-container>
              </td>
              <td><input class="search-patient-field   menstural-field" [(ngModel)]="customNewExam.Length"></td>
            <td>
                <input class="search-patient-field  menstural-field" [(ngModel)]="customNewExam.Price">
            </td>
            <td *ngIf="!ls?.premissions?.ApptsByRoom"><mat-form-field>
              <mat-label [ngClass]="['mat-select-value']">
                {{'appointments.gui.labels.Choose Practicing Doctor' | translate}}
              </mat-label>
              <mat-select [(ngModel)]="customNewExam.users" multiple [compareWith]="compareById" [ngClass]="['mat-select-value','mat-form-field']">
                <ng-container *ngFor="let e of this.ls.clinicUsers">
                <mat-option   [value]="e.UID" [ngClass]="['mat-select-value']">{{ e.Name }}</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field></td>
            <td *ngIf="ls?.premissions?.ApptsByRoom"><mat-form-field>
              <mat-label [ngClass]="['mat-select-value']">
                {{'appointments.gui.labels.Choose Practicing rooms' | translate}}
              </mat-label>
              <mat-select [(ngModel)]="customNewExam.users" multiple [compareWith]="compareById" [ngClass]="['mat-select-value','mat-form-field']">
                <ng-container *ngFor="let e of this.ls.activeRooms">
                <mat-option   [value]="e.AutoIndex" [ngClass]="['mat-select-value']">{{ ls.roomLabel(e) }}</mat-option>
                </ng-container>
              </mat-select>
            </mat-form-field></td>
            <td><input class="color-picker" [(ngModel)]="customNewExam.Color" type="color"></td>
            <td>
              <div style="display:grid; grid-template-columns:1fr 1fr; gap:0.1em 0.4em;">
                <label class="t-label-top">
                  <input type="checkbox" class="custom-check -sq" [(ngModel)]="customNewExam.Private"/>
                  <i class="customInput-display -sq" (dblclick)="customNewExam.Private = false"></i>
                  <span>{{ 'appointments.gui.labels.Private' | translate }}</span>
                </label>
                <label class="t-label-top">
                  <input type="checkbox" class="custom-check -sq" [(ngModel)]="customNewExam.Macabi"/>
                  <i class="customInput-display -sq" (dblclick)="customNewExam.Macabi = false"></i>
                  <span>{{ 'appointments.gui.hmo.Macabi' | translate }}</span>
                </label>
                <label class="t-label-top">
                  <input type="checkbox" class="custom-check -sq" [(ngModel)]="customNewExam.Clalit"/>
                  <i class="customInput-display -sq" (dblclick)="customNewExam.Clalit = false"></i>
                  <span>{{ 'appointments.gui.hmo.Clalit' | translate }}</span>
                </label>
                <label class="t-label-top">
                  <input type="checkbox" class="custom-check -sq" [(ngModel)]="customNewExam.Leumit"/>
                  <i class="customInput-display -sq" (dblclick)="customNewExam.Leumit = false"></i>
                  <span>{{ 'appointments.gui.hmo.Leumit' | translate }}</span>
                </label>
                <label class="t-label-top">
                  <input type="checkbox" class="custom-check -sq" [(ngModel)]="customNewExam.Meuhedet"/>
                  <i class="customInput-display -sq" (dblclick)="customNewExam.Meuhedet = false"></i>
                  <span>{{ 'appointments.gui.hmo.Meuhedet' | translate }}</span>
                </label>
                <label class="t-label-top">
                  <input type="checkbox" class="custom-check -sq" [(ngModel)]="customNewExam.IDF"/>
                  <i class="customInput-display -sq" (dblclick)="customNewExam.IDF = false"></i>
                  <span>{{ 'appointments.gui.selects.IDF' | translate }}</span>
                </label>
              </div>
            </td>
            <td><button style="white-space: nowrap;" class="orange-btn" (click)="saveNewExam(customNewExam)">
              {{'appointments.gui.buttons.Save New' | translate}}
            </button></td>
          </tr>
        </table>
  </div>
</div>
